import React, {useState} from 'react';
import {UpDownChevron} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/UpDownChevron/UpDownChevron';
import {AllFonts} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/AllFonts/AllFonts';
import './FontsDropdown.sass';

export const FontsDropdown = ({placeHolder, onChange, selectedFont}) => {
  const [showMenu, setShowMenu] = useState(true);

  const handleInputClick = (e) => {
    e.stopPropagation();
    setShowMenu((prevState) => !prevState);
  };

  return (
    <div className="fonts_dropdown_container" onClick={handleInputClick}>
      <div className="upper">
        <div className="title">{placeHolder}</div>
        <UpDownChevron up={showMenu} ratio={0.5} />
      </div>
      <div className={`fonts__container ${showMenu ? 'fonts__container--visible' : ''}`}>
        <div className="fonts__container__inner">
          <AllFonts onClick={onChange} selectedFont={selectedFont} />
        </div>
      </div>
    </div>
  );
};
